import Main from '@/views/administracion/configuracion/catalogos/fuentesfinancieras/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/fuentesfinancieras/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const fuentesFinancieras = [
  {
    path: 'fuentes-financieras',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoFuentesFinancieras',
        path: '/',
        meta: {
          title: 'Fuentes Financieras',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default fuentesFinancieras;
